import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild, ElementRef, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-metro-form-textarea',
  standalone: false,
  templateUrl: './metro-form-textarea.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MetroFormTextareaComponent),
      multi: true
    }
  ]
})
export class MetroFormTextareaComponent implements ControlValueAccessor {
  @Input() label = 'Description';
  @Input() placeholder = '';
  @Input() disabled = false;
  @Input() required = false;
  @Input() error: string | null = null;
  @Input() hint: string | null = null;
  @Input() minHeightClass = 'min-h-36';
  @Input() fullWidth = true;
  @Input() maxlength?: number;
  /** winepassport#376 — filas visibles del textarea. Default 4 (comportamiento previo). */
  @Input() rows = 4;

  @ViewChild('textareaEl') textareaEl?: ElementRef<HTMLTextAreaElement>;

  value: string = '';

  @Output() valueChange = new EventEmitter<string>();
  @Output() focused = new EventEmitter<void>();
  @Output() blurred = new EventEmitter<void>();

  // ControlValueAccessor
  onChange: any = () => {};
  onTouched: any = () => {};

  writeValue(value: any): void {
    this.value = value ?? '';
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  // Input handler
  onInput(ev: Event) {
    const val = (ev.target as HTMLTextAreaElement).value ?? '';
    this.value = val;
    this.valueChange.emit(val);
    this.onChange(val);
  }

  focus() {
    this.textareaEl?.nativeElement.focus();
  }
}
